// extracted by mini-css-extract-plugin
export default {"body":"DownloadPage_body__5UJxF","block":"DownloadPage_block__VhZst","title":"DownloadPage_title__q5tmt","content":"DownloadPage_content__0n4R-","hide":"DownloadPage_hide__VVJfI"};